import {
  SET_HOME_DOCUMENTS,
  RESET_INITIAL_HOME_STATE,
  SET_WITNESS_OBJ
} from "../actions/anonHomeForm";

const initialState = {
  documents: { files: [], size: 0 },
  witnessObj: null
};

export const anonHomeFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WITNESS_OBJ:
      return {...state, witnessObj: action.obj};
    case SET_HOME_DOCUMENTS:
      return { ...state, documents: action.documents };
    case RESET_INITIAL_HOME_STATE:
      return { ...initialState };
    default:
      return { ...state };
  }
};
